import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ExperienceMapper } from '@ninetailed/experience.js-utils';
function parseExperience(_ref) {
  var _experience$descripti, _experience$sys, _experience$ntVariant, _experience$ntVariant2;
  var experience = _ref.experience,
    data = _ref.data;
  return _objectSpread(_objectSpread({
    name: experience.ntName,
    type: experience.ntType,
    config: experience.ntConfig
  }, experience.ntAudience ? {
    audience: {
      id: experience.ntAudience.ntAudienceId,
      name: experience.ntAudience.ntName
    }
  } : {}), {}, {
    description: (_experience$descripti = experience.description) !== null && _experience$descripti !== void 0 ? _experience$descripti : '',
    id: experience === null || experience === void 0 ? void 0 : (_experience$sys = experience.sys) === null || _experience$sys === void 0 ? void 0 : _experience$sys.id,
    variants: (_experience$ntVariant = experience.ntVariantsCollection) === null || _experience$ntVariant === void 0 ? void 0 : (_experience$ntVariant2 = _experience$ntVariant.items) === null || _experience$ntVariant2 === void 0 ? void 0 : _experience$ntVariant2.map(function (variant) {
      var _variant$sys;
      return {
        id: variant === null || variant === void 0 ? void 0 : (_variant$sys = variant.sys) === null || _variant$sys === void 0 ? void 0 : _variant$sys.id,
        // use always entry and data format to match with the adapters (e.g. PromoBannerAdapter)
        entry: _objectSpread({}, variant),
        data: data // contains scrollbarWidth, shouldPreloadImage, etc. passed by BladeRenderer or ScreenComponent
      };
    })
  });
}

export function filterAndMapExperiences(_ref2) {
  var experiences = _ref2.experiences,
    data = _ref2.data;
  if (!experiences) {
    return null;
  }
  var mappedExperiences = experiences.map(function (experience) {
    return parseExperience({
      experience: experience,
      data: data
    });
  });
  return mappedExperiences.filter(ExperienceMapper.isExperienceEntry).map(ExperienceMapper.mapExperience);
}
function parseAudience(audience) {
  var _audience$ntDescripti;
  return {
    id: audience.ntAudienceId,
    name: audience.ntName,
    description: (_audience$ntDescripti = audience.ntDescription) !== null && _audience$ntDescripti !== void 0 ? _audience$ntDescripti : ''
  };
}
function mapAudiences(audiences) {
  return audiences.map(function (audience) {
    return parseAudience(audience);
  });
}